// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.income-analytics-container {
  padding: 30px;
  background-color: #fff;
  min-height: calc(100vh - 60px);
}

.income-header {
  margin-bottom: 40px;
}

.income-year-total {
  margin-bottom: 30px;
  text-align: left;
}

.year-heading {
  font-size: 18px;
  color: #666;
  margin-bottom: 10px;
  font-weight: 500;
  text-align: left;
}

.income-total {
  font-size: 32px;
  font-weight: bold;
  color: #000;
  text-align: left;
}

.income-chart-section {
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.month-navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

.month-nav-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c7ae0;
  cursor: pointer;
  padding: 0 20px;
}

.month-display {
  font-size: 24px;
  font-weight: 500;
  margin: 0 30px;
}

.income-chart {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 300px;
  margin-bottom: 30px;
  padding: 10px 20px 20px 20px;
  overflow-x: auto;
}

.chart-bar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 12%;
  min-width: 100px;
}

.chart-bar-value {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #555;
  text-align: center;
  height: 22px;
  white-space: nowrap;
  padding: 0 5px;
}

.chart-bar {
  width: 90px;
  background-color: #e0e0e0;
  border-radius: 4px;
  transition: height 0.5s ease;
}

.chart-bar.current-month {
  background-color: #3F51B5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chart-bar.no-data {
  background-color: #e0e0e0;
  opacity: 0.5;
}

.chart-bar-month {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
  text-align: center;
}

.chart-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 20px 0;
}

.monthly-details {
  padding-top: 20px;
  text-align: left;
}

.month-heading {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-decoration: underline;
  text-underline-offset: 8px;
  text-align: left;
}

.month-stats {
  font-size: 18px;
  line-height: 1.6;
  text-align: left;
}

.month-stat {
  color: #333;
  margin-bottom: 5px;
  text-align: left;
  font-size: 20px;
}

.company-count {
  color: #3F51B5;
  font-weight: bold;
}

.month-income {
  color: #333;
  font-size: 20px;
  text-align: left;
}

.income-amount {
  color: #3F51B5;
  font-weight: bold;
}

/* 로딩 및 에러 표시 스타일 추가 */
.loading-indicator, .error-message {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 18px;
  color: #666;
}

.error-message {
  color: #d32f2f;
}

@media (max-width: 768px) {
  .income-chart {
    padding: 0 10px;
  }
  
  .chart-bar-container {
    min-width: 85px;
  }
  
  .chart-bar {
    width: 70px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/admin/AdminIncomeAnalytics.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".income-analytics-container {\n  padding: 30px;\n  background-color: #fff;\n  min-height: calc(100vh - 60px);\n}\n\n.income-header {\n  margin-bottom: 40px;\n}\n\n.income-year-total {\n  margin-bottom: 30px;\n  text-align: left;\n}\n\n.year-heading {\n  font-size: 18px;\n  color: #666;\n  margin-bottom: 10px;\n  font-weight: 500;\n  text-align: left;\n}\n\n.income-total {\n  font-size: 32px;\n  font-weight: bold;\n  color: #000;\n  text-align: left;\n}\n\n.income-chart-section {\n  background-color: white;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.month-navigation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n.month-nav-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6c7ae0;\n  cursor: pointer;\n  padding: 0 20px;\n}\n\n.month-display {\n  font-size: 24px;\n  font-weight: 500;\n  margin: 0 30px;\n}\n\n.income-chart {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  height: 300px;\n  margin-bottom: 30px;\n  padding: 10px 20px 20px 20px;\n  overflow-x: auto;\n}\n\n.chart-bar-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 12%;\n  min-width: 100px;\n}\n\n.chart-bar-value {\n  margin-bottom: 10px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #555;\n  text-align: center;\n  height: 22px;\n  white-space: nowrap;\n  padding: 0 5px;\n}\n\n.chart-bar {\n  width: 90px;\n  background-color: #e0e0e0;\n  border-radius: 4px;\n  transition: height 0.5s ease;\n}\n\n.chart-bar.current-month {\n  background-color: #3F51B5;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.chart-bar.no-data {\n  background-color: #e0e0e0;\n  opacity: 0.5;\n}\n\n.chart-bar-month {\n  margin-top: 10px;\n  font-size: 14px;\n  color: #666;\n  text-align: center;\n}\n\n.chart-divider {\n  height: 1px;\n  background-color: #e0e0e0;\n  margin: 20px 0;\n}\n\n.monthly-details {\n  padding-top: 20px;\n  text-align: left;\n}\n\n.month-heading {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  text-decoration: underline;\n  text-underline-offset: 8px;\n  text-align: left;\n}\n\n.month-stats {\n  font-size: 18px;\n  line-height: 1.6;\n  text-align: left;\n}\n\n.month-stat {\n  color: #333;\n  margin-bottom: 5px;\n  text-align: left;\n  font-size: 20px;\n}\n\n.company-count {\n  color: #3F51B5;\n  font-weight: bold;\n}\n\n.month-income {\n  color: #333;\n  font-size: 20px;\n  text-align: left;\n}\n\n.income-amount {\n  color: #3F51B5;\n  font-weight: bold;\n}\n\n/* 로딩 및 에러 표시 스타일 추가 */\n.loading-indicator, .error-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-size: 18px;\n  color: #666;\n}\n\n.error-message {\n  color: #d32f2f;\n}\n\n@media (max-width: 768px) {\n  .income-chart {\n    padding: 0 10px;\n  }\n  \n  .chart-bar-container {\n    min-width: 85px;\n  }\n  \n  .chart-bar {\n    width: 70px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
